export default __webpack_public_path__ + "static/media/place_holder_wishlist.19b80241.svg";